const renderSearchBox = (renderOptions, isFirstRender) => {
  const { refine, widgetParams } = renderOptions;

  if (isFirstRender) {
    widgetParams.container.addEventListener("input", (e) => {
      refine(e.target.value);

      if (e.target.value === "") {
        widgetParams.dropdown.reset();
      }
    });

    return;
  }
};

export const searchInput =
  window.instantsearch.connectors.connectSearchBox(renderSearchBox);
